import { Box } from "@mui/material";
import ContactDrawer from "components/Contact/ContactDrawer";
import LeadDrawer from "components/Contact/LeadDrawer";
import React from "react";

const ViewContact = () => {
  return (
    <Box height="100%" sx={{ overflowY: "auto" }}>
       <LeadDrawer />
      <ContactDrawer />
    </Box>
  );
};

export default ViewContact;
